<template>
  <div class="error">
    <span class="icon fa-4x">
      <i :class="iconClasses" />
    </span>
    <div class="description">
      <span class="greetings">Oops, something went wrong...</span>
      <section class="has-text-grey">
        <div v-if="message" class="detail">
          <span class="e__label has-text-dark">Error:</span>
          {{ message }}
        </div>
        <div v-if="url">
          <span class="e__label has-text-dark">url:</span>
          {{ url }}
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iconClasses: {
      type: String,
      default: 'fa-solid fa-exclamation-circle',
    },
    message: {
      type: String,
      default: 'default error message',
    },
    url: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.error {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3rem 1rem;
  margin-bottom: auto;
  text-align: center;
}

.error .icon {
  margin: 3rem;
}

.error .description .greetings {
  font-size: 1.5rem;
}

.error .description .detail .e__label {
  font-weight: 600;
}
</style>
